import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import constants from './constants.js';
import { setInterval, clearInterval } from 'timers';
import {Button, Popover} from 'react-bootstrap';
import BuyButton from './BuyButton.js';
import SellButton from './SellButton.js';
import windowSize from 'react-window-size';


class Wallet extends Component {

  constructor(props) {
    super(props);
    this.state = {
      contractInstance: null,
      currentBalance: 0,
      totalSupply: 0,
      tierBudget: 0,
      buyPrice: 0,
      sellPrice: 0,
      ethPrice: 0,
      contractBalance: 0,
      accountError: false,
      tryOnce: false
    };

    this.web3 = null;
    this.refreshWallet = this.refreshWallet.bind(this);
    this.findAccounts = null;
  }

  refreshWallet(contractInstance=null) {
    this.web3.version.getNetwork((err, netId) => {
      if (netId !== "1") {
        this.setState({
          networkError: true
        });
      } else {
        this.setState({
          networkError: false
        });
      }
    });
    if (this.web3.eth.accounts.length === 0) {
      if (this.state.tryOnce) {
        this.setState({accountError: true});
      } else {
        this.setState({tryOnce: true});
      }
    } else if (this.state.contractInstance || contractInstance) {
      if (this.state.contractInstance) {
        contractInstance = this.state.contractInstance;
      }
      if (this.web3.eth.accounts.length > 0) {
        contractInstance.balanceOf(this.web3.eth.accounts[0], (error, result) => {
          this.setState({currentBalance: result / constants.decimals, accountError: false});
        });
        clearInterval(this.findAccounts);
      }
      contractInstance.totalSupply((error, result) => {       
        this.setState({totalSupply: result / constants.decimals});
      });
      contractInstance.tierBudget((error, result) => {       
        this.setState({tierBudget: result / constants.decimals});
      });
      contractInstance.buyPrice((error, result) => {       
        this.setState({buyPrice: constants.convertWeiToEth(result) * constants.decimals});
      });
      contractInstance.sellPrice((error, result) => {       
        this.setState({sellPrice: constants.convertWeiToEth(result) * constants.decimals});
      });
      this.web3.eth.getBalance(constants.contract_address, (error, result) => {
        this.setState({contractBalance: constants.convertWeiToEth(result)});
      });
    }
    fetch('https://api.coinbase.com/v2/prices/ETH-USD/sell')
      .then(data => data.json())
      .then(data => {this.setState({ethPrice: data['data']['amount']});});

  }

  componentDidMount() {
    this.web3 = new window.Web3(window.web3.currentProvider);

    var contract = this.web3.eth.contract(constants.abi);
    var contractInstance = contract.at(constants.contract_address);

    this.setState({
      contractInstance: contractInstance
    });
    this.refreshWallet(contractInstance);
    setInterval(this.refreshWallet, 10000);
    this.findAccounts = setInterval(this.refreshWallet, 200);
  }

  render() {
    var colclassName = "col";
    if (this.props.windowWidth > 800) {
      colclassName += " card";
    }
    if (this.state.networkError) {
      return (
        <div className="card" style={{margin: 50}}>
          <div className="card-body">
            <div className="card-title">Network Error</div>
            <p className="card-text">You seem to be on the wrong network! Go to MetaMask and switch to the Main Ethereum Network!</p>
              <button type="button" className="btn btn-primary" onClick={this.refreshWallet}>
          Refresh
        </button>
          </div>
        </div>
      );
    }
    if (this.state.accountError) {
      return (
        <div className="card" style={{margin: 50}}>
          <div className="card-body">
            <div className="card-title">Account Error</div>
            <p className="card-text">We can't seem to access your account :( Open up MetaMask and unlock your account!</p>
              <button type="button" className="btn btn-primary" onClick={this.refreshWallet}>
          Refresh
        </button>
          </div>
        </div>
      );
    }
    return (
      <div className="App">
              <div style={{marginTop: 15}} >
        <h5>Current ETH Price: ${this.state.ethPrice}</h5>
        <h5>Current Contract Balance: {this.state.contractBalance} ETH</h5>
        <i className="fa fa-warning" style={{color: '#ffbc19'}}></i> Prices will double once <b>{this.state.tierBudget}</b> more PonziCoins ({(this.state.tierBudget * this.state.buyPrice).toFixed(2)} ETH) are sold!
        </div>
      
      <div className="container">
        <div className="row">
          <div className={colclassName} style={{margin: 20}}>
            <div className="card-body">
              <h4 className="card-title">Buy Price</h4>
              <h1 className="card-text">{this.state.buyPrice} ETH</h1>
              <p className="card-text" style={{marginTop: -15}}>${(this.state.buyPrice * this.state.ethPrice).toFixed(2)}</p>

              <p className="card-text" style={{color: 'green', marginTop: -20}}>&#x25B2; (100.0%)</p>
 
              <BuyButton contractInstance={this.state.contractInstance} price={this.state.buyPrice} />
            </div>
          </div>
          <div className={colclassName} style={{margin: 20}}>
            <div className="card-body">
              <h4 className="card-title">Sell Price</h4>
              <h1 className="card-text">{this.state.sellPrice} ETH</h1>
              <p className="card-text" style={{marginTop: -15}}>${(this.state.sellPrice * this.state.ethPrice).toFixed(2)}</p>
              <p className="card-text" style={{color: 'green', marginTop: -20}}>&#x25B2; (100.0%)</p>

              <SellButton contractInstance={this.state.contractInstance} balance={this.state.currentBalance} price={this.state.sellPrice}/>
            </div>
          </div>
        </div>
        <div className="row">
          <div className={colclassName} style={{margin: 20}}>
            <div className="card-body">
              <h4 className="card-title">Balance</h4>
              <h1 className="card-text">{this.state.currentBalance}</h1>
              <p className="card-text" style={{fontSize:20, marginTop:-10}}>PonziCoins</p>
          </div>
          </div>
          <div className={colclassName} style={{margin: 20}}>
            <div className="card-body">
             <h4 className="card-title">Paper Value</h4>
              <h1 className="card-text">{(this.state.currentBalance * this.state.buyPrice).toFixed(3)}</h1>
              <p className="card-text" style={{fontSize:20, marginTop:-10}}>ETH</p>
              <p className="card-text" style={{marginTop: -15}}>(${(this.state.buyPrice * this.state.ethPrice * this.state.currentBalance).toFixed(2)})</p>

            </div>
          </div>
          <div className={colclassName} style={{margin: 20}}>
            <div className="card-body">
              <h4 className="card-title">Real Value</h4>
              <h1 className="card-text">{(this.state.currentBalance * this.state.sellPrice).toFixed(3)}</h1>
              <p className="card-text" style={{fontSize:20, marginTop:-10}}>ETH</p>
              <p className="card-text" style={{marginTop: -15}}>(${(this.state.sellPrice * this.state.ethPrice * this.state.currentBalance).toFixed(2)})</p>

            </div>
          </div>
        </div>
        
      </div>
      </div>
    );
  }
}

export default windowSize(Wallet);



// WEBPACK FOOTER //
// ./src/Wallet.js